import { Link } from "react-router-dom";
import { Instagram, Youtube, Linkedin, Facebook, ArrowUpRight, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-chai-ink text-white" data-testid="footer">
      <div className="w-full max-w-none px-4 md:px-8 lg:px-12 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-16 gap-y-14 border-b border-white/15 pb-16">
          <div className="md:col-span-6">
            <h2 className="font-heading text-6xl md:text-8xl font-bold tracking-tighter leading-[0.9]">
              Keep it Simple.<br /><span className="text-chai-yellow">Let&apos;s Simplify.</span>
            </h2>
            <p className="font-body text-lg text-white/60 mt-6 max-w-md">
              Learning, Growth & Inspiration — Simplified. Because when learning is as simple as a cup of chai, anything is possible.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-chai-red mb-6">Explore</p>
            <ul className="space-y-5 font-body text-lg tracking-wide">
              <li><Link to="/about" className="hover:text-chai-yellow transition-colors" data-testid="footer-about">About</Link></li>
              <li><Link to="/services" className="hover:text-chai-yellow transition-colors" data-testid="footer-services">Services</Link></li>
              <li><Link to="/gallery" className="hover:text-chai-yellow transition-colors" data-testid="footer-gallery">Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-chai-yellow transition-colors" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-chai-red mb-6">Connect</p>
            <div className="flex flex-col gap-5 font-body text-lg tracking-wide">
              <a href="mailto:ask.chaied@gmail.com" className="flex items-center gap-2 hover:text-chai-yellow transition-colors break-all" data-testid="footer-email"><Mail size={18} /> ask.chaied@gmail.com</a>
              <a href="tel:+917982470821" className="flex items-center gap-2 hover:text-chai-yellow transition-colors" data-testid="footer-phone"><Phone size={18} /> +91 79824 70821</a>
              <a href="https://www.instagram.com/chaied_simplified?igsh=MWlkb21pb3ZtampubA==" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-chai-yellow transition-colors" data-testid="social-instagram"><Instagram size={18} /> Instagram</a>
              <a href="https://www.youtube.com/@ChaiEDSimplified" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-chai-yellow transition-colors" data-testid="social-youtube"><Youtube size={18} /> YouTube</a>
              <a href="https://www.linkedin.com/company/112704339/admin/dashboard/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-chai-yellow transition-colors" data-testid="social-linkedin"><Linkedin size={18} /> LinkedIn</a>
              <a href="https://www.facebook.com/profile.php?id=61586406668172" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-chai-yellow transition-colors" data-testid="social-facebook"><Facebook size={18} /> Facebook</a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8">
          <p className="font-mono text-xs uppercase tracking-widest text-white/50">© {new Date().getFullYear()} ChaiED. All rights reserved.</p>
          <a href="https://chaied.com" target="_blank" rel="noreferrer" className="font-mono text-xs uppercase tracking-widest flex items-center gap-1 hover:text-chai-yellow transition-colors" data-testid="footer-domain">
            chaied.com <ArrowUpRight size={14} />
          </a>
        </div>
      </div>
    </footer>
  );
}
